import { Component, EventEmitter, Input, Output } from '@angular/core';

/** Alerta modal reutilizable basada en el patrón Alerta Modal de GOV.CO v5. */
@Component({
  selector: 'sr-psa-govco-alert-modal',
  standalone: true,
  templateUrl: './govco-alert-modal.component.html',
  styleUrl: './govco-alert-modal.component.css'
})
export class GovcoAlertModalComponent {
  @Input() open = false;
  @Input() title = 'Advertencia';
  @Input() message = '';
  @Input() actionLabel = 'Aceptar';
  @Input() variant: 'warning' | 'success' | 'error' = 'warning';
  @Output() readonly closed = new EventEmitter<void>();

  get icon(): string { return this.variant === 'success' ? '✓' : this.variant === 'error' ? '×' : '!'; }
}
